import httpService from '@/modules/common/services/httpService';
import gatewayService from '@/modules/common/services/gatewayService';
import toScheduledPaymentsRule from '@/modules/payments/utils/paymentPlanUtil';

const baseRoute = '/business/payments/v1';
const v2Route = '/v2';
const paymentPlansRoute = '/v3/sales/payment_plans';

const fetchScheduledPaymentsV1 = async (uid) => httpService.get(`${baseRoute}/scheduled_payments_rules/${uid}`)
  .then((res) => res.data?.data?.scheduled_payments_rule);

const fetchPaymentsByScheduledPaymentsUid = async (uid) => httpService.get(`${baseRoute}/payments?filter[scheduled_payments_rule_uid]=${uid}`)
  .then((res) => res.data?.data?.payments);

const fetchPaymentsByPaymentStatusUid = async (uid) => httpService.get(`${baseRoute}/payments?filter[payment_status_uid_in]=${uid}`)
  .then((res) => res.data?.data?.payments);

const cancelScheduledPaymentsV1 = async (uid) => httpService.put(`${baseRoute}/scheduled_payments_rules/${uid}/cancel`)
  .then((res) => res.data?.data?.scheduled_payments_rule);

// v3 payment_plans replaces the two scheduled_payments_rules calls above while
// rollout.payments.payables_linked_payment_plans rolls out. Both return the v1 shape, so the store
// and the side pane are unaware of which API served them.
// TODO: (VCITA2-15351 - flag cleanup): delete the two V1 methods above and drop the suffix here.
const fetchPaymentPlan = async (uid) => gatewayService.get(`${paymentPlansRoute}/${uid}`)
  .then((res) => toScheduledPaymentsRule(res.data.data));

const fetchPaymentPlans = async (params) => gatewayService.get(paymentPlansRoute, params)
  .then((res) => res.data.data);

// v3 has no cancel route - cancelling is a status update on the plan itself.
const cancelPaymentPlan = async (uid) => gatewayService.patch(`${paymentPlansRoute}/${uid}`, { status: 'cancelled' })
  .then((res) => toScheduledPaymentsRule(res.data.data));

const refundPayment = async (payload) => httpService.post(`${baseRoute}/refunds`, payload)
  .then((res) => res.data);

const waivePayment = async (paymentStatusUid, payload) => httpService.put(`${v2Route}/payment_statuses/${paymentStatusUid}/waive_payment`, payload)
  .then((res) => res);

const fetchPayment = async (paymentUid) => httpService.get(`${v2Route}/payments/${paymentUid}?full=true&localized=true`)
  .then((res) => res.data);

// The show action renders the decorator at the top level, with no data envelope.
const fetchPaymentRequest = async (paymentStatusUid) => httpService.get(`${v2Route}/payment_statuses/${paymentStatusUid}`)
  .then((res) => res.data);

export default {
  fetchScheduledPaymentsV1,
  fetchPaymentsByScheduledPaymentsUid,
  cancelScheduledPaymentsV1,
  fetchPaymentPlan,
  fetchPaymentPlans,
  cancelPaymentPlan,
  refundPayment,
  waivePayment,
  fetchPayment,
  fetchPaymentRequest,
  fetchPaymentsByPaymentStatusUid,
};
